import { useNavigate } from "react-router-dom";
import "./ApplicationSubmittedStep.css";

function ApplicationSubmittedStep({
    providerData,
    providerId,
}) {
  const navigate = useNavigate();

  // Temporary Application ID
  const applicationId =
    "HF" + Date.now().toString().slice(-8);

  return (

    <div className="application-submitted">

      <div className="success-icon">
        ✅
      </div>

      <h1>
        Application Submitted Successfully
      </h1>

      <p className="thank-you">

        Thank you for registering as a HomeFoods Provider.

      </p>

      <div className="application-card">

        <div className="row">

          <span>Application ID</span>

          <strong>{applicationId}</strong>

        </div>

        <div className="row">

          <span>Status</span>

          <strong className="pending">
            Pending Admin Approval
          </strong>

        </div>

        <div className="row">

          <span>Estimated Review Time</span>

          <strong>
            24 - 48 Hours
          </strong>

        </div>

      </div>

      <div className="important-info">

        <h3>
          What happens next?
        </h3>

        <ul>

          <li>
            Our team will review your application.
          </li>

          <li>
            Your business details and documents will be verified.
          </li>

          <li>
            After approval, you'll receive an email.
          </li>

          <li>
            You'll then be asked to create your password.
          </li>

          <li>
            After creating your password, you can log in and start selling.
          </li>

        </ul>

      </div>

      <div className="submitted-buttons">

        <button
          onClick={() => navigate("/")}
        >
          Go to Home
        </button>

        <button
    onClick={() =>
        navigate(
            `/provider/application-status/${providerId}`
        )
    }
>
    Track Application
</button>

      </div>

    </div>

  );

}

export default ApplicationSubmittedStep;